<template>
  <!-- 材质/风格等 -->
  <Popup v-model="show" position="right" @close="onClose" :style="{ width: '90%', height: '100vh' }">
    <div class="ather-popup-box">
      <span class="apb-title">筛选</span>
      <div class="apb-list-box">
        <div class="apb-item-box">
          <div class="title-box mt-32">
            <span class="sub-title">材质</span>
          </div>
          <div class="grid-box">
            <span class="overflow" @click="onCzClick(item)" :class="{ active: goodsCzArr.indexOf(item) >= 0 }"
              v-for="item, index in czList" :key="index">{{ item }}</span>
          </div>
        </div>
        <div class="apb-item-box" v-for="item, index in tags" :key="index">
          <div class="title-box">
            <span class="sub-title">{{ item.nm }}</span>
            <span class="show-opt" :class="{ 'show-opt-active': item.show }" @click="$set(item, 'show', !item.show)"
              v-if="item.isShow">{{ item.show ? '收起' : '展开' }}<Icon class="show-icon" color="#333" name="arrow-down">
              </Icon></span>
          </div>
          <div class="grid-box">
            <span class="overflow" @click="onTagClick('tagFilter' + item.id, tag)"
              :class="{ active: params['tagFilter' + item.id] && params['tagFilter' + item.id].indexOf(tag) >= 0 }"
              v-for="tag, index in item.show ? item.subList1 : item.subList2" :key="index">{{ tag }}</span>
          </div>
        </div>
        <i class="line"></i>
        <span class="sub-title">价格区间</span>
        <div class="input-box">
          <input v-model="params.priceMin" type="text" inputmode="numeric" v-enter-Price placeholder="最低价" />
          <span>-</span>
          <input v-model="params.priceMax" type="text" inputmode="numeric" v-enter-Price placeholder="最高价" />
        </div>
        <span class="sub-title">最小库存</span>
        <div class="input-box">
          <input v-model="params.kcMin" type="text" v-enter-number inputmode="numeric" placeholder="最小库存" />
        </div>
      </div>
      <div class="apb-bottom-box">
        <van-button type="primary" plain @click="onAtherClean">重置</van-button>
        <van-button type="primary" @click="onAtherConfirm">确定</van-button>
      </div>
    </div>
  </Popup>
</template>

<script>
import { Popup, Icon } from 'vant';
export default {
  props: {
    value: [Boolean],
    czList: {
      type: Array,
      redirect: false,
      default: function () {
        return []
      }
    },
    tags: {
      type: Array,
      redirect: false,
      default: function () {
        return []
      }
    },
    vl: [Object],
  },
  components: {
    Popup, Icon
  },
  data() {
    return {
      show: false,
      params: {},
      goodsCzArr: [],
    }
  },
  watch: {
    value(val) {
      if (val) {
        this.params = JSON.parse(JSON.stringify(this.vl));
        if (this.params.goodsCz) {
          this.goodsCzArr = this.params.goodsCz.split(',')
        } else {
          this.goodsCzArr = [];
        }
        this.params.tags.forEach(item => {
          this.params['tagFilter' + item.id] = item.vl.split(',');
        });

        console.log(this.params);

      }

      this.show = val;
    },
  },
  created() {
  },

  computed: {
  },
  methods: {
    onClose() {
      this.$emit('input', false)
    },
    //材质
    onCzClick(name) {
      let index = this.goodsCzArr.indexOf(name);
      if (index >= 0) {
        this.goodsCzArr.splice(index, 1);
      } else {
        this.goodsCzArr.push(name);
      }
      this.$forceUpdate()
    },
    //标签
    onTagClick(key, item) {
      if (!this.params[key]) {
        this.$set(this.params, key, [item])
        return
      }
      let index = this.params[key].indexOf(item);
      if (index >= 0) {
        this.params[key].splice(index, 1);
      } else {
        this.params[key].push(item);
      }
      this.$forceUpdate()
    },
    //材质/风格等清除
    onAtherClean() {
      this.goodsCzArr = [];
      this.params.goodsCz = '';
      this.params.tags = [];
      this.params.kcMin = '';
      this.params.priceMin = '';
      this.params.priceMax = '';
      for (const key in this.params) {
        if (key.startsWith('tagFilter')) {
          this.params[key] = []
        }
      }
    },
    //材质/风格等确认
    onAtherConfirm() {
      let tags = []
      for (const key in this.params) {
        if (key.startsWith('tagFilter') && this.params[key] && this.params[key].length > 0) {
          tags.push({
            id: key.replace('tagFilter', ''),
            vl: this.params[key].join(',')
          })
        }
      }
      this.params.goodsCz = this.goodsCzArr.join(',')
      this.params.tags = tags;
      let data = {};
      for (const key in this.params) {
        if (!key.startsWith('tagFilter')) {
          data[key] = this.params[key];
        }
      }
      data.page = 1;
      this.show = false;
      this.$emit('onConfirm', data)
    }
  }
}
</script>

<style scoped lang="less">
.ather-popup-box {
  display: flex;
  flex-direction: column;
  height: 100%;

  .apb-title {
    height: 92px;
    border-bottom: 1px solid #DCDCDC;
    color: #333;
    text-align: center;
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: 92px;
  }

  .apb-list-box {
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
    flex: 1;

    >* {
      flex-shrink: 0;
    }

    .apb-item-box {
      display: flex;
      flex-direction: column;
      flex-shrink: 0;

      .title-box {
        margin: 38px 32px 0 0;
        display: flex;
        align-items: center;


        .show-opt {
          color: #333;
          font-size: 24px;
          font-style: normal;
          font-weight: 400;
          margin-left: auto;

          .show-icon {
            margin-left: 5px;
            transform: rotate(0deg);
            transition: all 0.3s;
          }

          &-active {
            .show-icon {
              transform: rotate(180deg);
            }
          }
        }
      }



      .grid-box {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-gap: 18px 18px;
        margin: 18px 32px 0;

        >span {
          background: #f4f4f4;
          border-radius: 4px;
          width: 100%;
          height: 68px;
          color: #333;
          font-size: 26px;
          font-style: normal;
          font-weight: 400;
          line-height: 68px;
          text-align: center;
          padding: 0 8px;
          box-sizing: border-box;
        }

        .active {
          color: #FFF;
          background: #FF6634;
          font-weight: bold;
        }
      }
    }


    .line {
      background: #F4F4F4;
      height: 8px;
      margin: 38px 0;
    }

    .input-box {
      display: flex;
      margin: 18px 32px 32px;
      align-items: center;

      >input {
        border-radius: 80px;
        border: 1px solid #DCDCDC;
        background: #F4F4F4;
        width: 260px;
        height: 68px;
        color: #333;
        font-size: 26px;
        font-style: normal;
        font-weight: bold;
        padding: 0 44px;
        box-sizing: border-box;
      }

      >span {
        color: #333;
        font-size: 32px;
        font-style: normal;
        font-weight: bold;
        margin: 0 24px;
      }
    }

  }

  .apb-bottom-box {
    height: 116px;
    display: flex;
    border-top: 1px solid #DCDCDC;
    align-items: center;
    padding: 0 14px;

    .van-button {
      flex: 1;
      margin: 12px;
      border-radius: 116px;
      font-size: 28px;
      font-weight: bold;
    }
  }

}

.sub-title {
  color: #333;
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: 36px;
  margin-left: 32px;
}

.mt-32 {
  margin-top: 32px !important;
}
</style>
